import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

// Plugins
dayjs.extend(isSameOrBefore)
